export enum HeaderOption {
  DOWNLOAD = 'DOWNLOAD',
  EDIT = 'EDIT',
  FAVORITE = 'FAVORITE',
  VIEW_DATA = 'VIEW_DATA',
}

export enum PillId {
  AWAITING = 'awaiting',
  SEQUENCED = 'sequenced',
  RECEIVED = 'received',
}

export interface Pill {
  id: string;
  label: string;
}

export interface CollectionAndSequencingProps {
  sectionTitle?: string;
}
